import { ready } from './vendor/brei-project-utils.js';

import { filters } from './modules/filters.js';
import { results } from './modules/results.js';

// Example of importing a custom module
// import { primaryNav } from './modules/primaryNav';

const aggregate = {

	init() {
		filters.init();
		results.init();		
	},

};

ready(function () {
	aggregate.init();
});
